import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import VALUES from 'core/data-model/constants/values'
import { getAge } from 'quick-quote/insured-information/selectors'
import { editRiderSelectedPlan, updateSelectedPlan } from 'quick-quote/product-common/coverage-plan/actions'
import {
  getAvaliableOptionPlanPARider,
  getOptionPlanPARider,
  getRiderOccupationFactorForPARider,
} from 'quick-quote/product-pa/coverage-plan/selectors'
import { SELECT_PRODUCT } from 'quick-quote/product-selection/actions'

/**
 * createProductPAFunc
 * @param {ReturnType<import('core/data-model/basic-plan/repository').createBasicPlanRepository>} basicPlanRepository
 * @param {ReturnType<import('core/service/rider/premium-rate').createRiderPremiumRateService>} riderPremiumRateService
 * @param {ReturnType<import('quick-quote/product-common/coverage-plan/sagas').createProductCommonCoverageFunc>} productCommonCoverageFunc
 */
export function createProductPAFunc(basicPlanRepository, riderPremiumRateService, productCommonCoverageFunc) {
  const { store } = require('store')

  async function resolveRiderOptionForPlan(displayProduct, rider) {
    const state = store.getState()

    const riderOccupationFactor = getRiderOccupationFactorForPARider(state)
    const availableOptionPlanPARider = getAvaliableOptionPlanPARider(state)
    const insuredAge = getAge(state)

    const result = await riderPremiumRateService.calculatePremiumOptionPlanPA(
      rider,
      riderOccupationFactor,
      availableOptionPlanPARider,
      insuredAge
    )

    // merge result to component
    const clones = _.cloneDeep(availableOptionPlanPARider)
    for (let clone of clones) {
      const match = result.find((r) => r.code === clone.planCode)
      if (match) {
        clone.premium = match.premiumRate
      }
    }

    return clones
  }

  function* setProductDefaultsPA(action) {
    const displayProduct = action.payload
    if (displayProduct.category !== VALUES.PA) return

    const defaults = yield call(basicPlanRepository.getProductDefaults, displayProduct.basicPlanCode)
    if (defaults) {
      yield put(updateSelectedPlan(defaults.code))
      yield call(productCommonCoverageFunc.populateAvailableRiders)
      const optionPlanPA = yield select(getOptionPlanPARider)
      const planGroupPA = _.find(optionPlanPA, { planCode: defaults.riderCode })
      if (planGroupPA) {
        yield put(
          editRiderSelectedPlan('PARIDER', { planCode: planGroupPA.planCode, packageDetail: planGroupPA.package })
        )
      }
    }
  }

  return {
    setProductDefaultsPA,
    resolveRiderOptionForPlan,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { PA } = serviceWrapper.products
  yield [takeLatest(SELECT_PRODUCT, PA.setProductDefaultsPA)]
}

export const sagas = watchers
